<template>
  <div id="footer">
    <div class="ws">
      <ul class="font">
        <li class="l font">
          <a-icon type="facebook" />
        </li>
        <li class="l">
          <a-icon type="instagram" />
        </li>
        <li class="l">
          <a-icon type="linkedin" />
        </li>
        <li class="l">
          <a-icon type="twitter" />
        </li>
        <li class="l">
          <a-icon type="behance" />
        </li>
      </ul>
      <p style="margin:0px;padding:0px;">
        Copyright © 2018 Awesome.com. All rights reserved.
        <a href="#">Awesome</a>
        - Collect from
        <a href="#">Awesome</a>
      </p>
      <p style="margin:0px; padding:0px;">
        Address: 1B 489 Nicholson Road Canningvale 6155
      </p>
      <p  style="margin:0px; padding:0px;">
        Email : admin@awesomewarehouse.com.au
      </p>
    </div>
  </div>
</template>
<script>
export default {
  components: {}
}
</script>

<style lang="scss" scoped>
#footer {
  width: 100%;
  height: 2rem;
  background: #f8f9fd;
  // position: fixed;
  // bottom: 0;
  .ws {
    ul.font {
      height: 0.625rem;
      margin-bottom: 0;
      padding: 0.375rem 0;
      margin-left: 6.25rem;
       color:#a5adb3;
      li {
        text-align: center;
        margin: 0 0.125rem;
        cursor: pointer;
        &:hover{
            color:#23527c;
        }
      }
    }
    p {
      padding: 0.125rem 0;
      text-align: center;
      color:#a5adb3;
      font-weight: 500;
      a{
         color:#a5adb3;
      }
    }
  }
}
</style>
